import "./PackageCard.css";

import { useState } from "react";
import { Check, Star } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { trackWhatsAppConversion } from "../utils/googleAds";

import PackageDetailsModal from "./PackageDetailsModal";

const PackageCard = ({
  icon,
  title,
  price,
  description,
  features = [],
  details = [],
  idealFor,
  delivery,
  popular = false,
  customPrice = false,
}) => {

  const [showDetails, setShowDetails] = useState(false);

  const phoneNumber = "919653304639";

  /* =========================
     WHATSAPP
  ========================= */

  const message = customPrice
    ? `Hi, I'm interested in your ${title}. I'd like to discuss my requirements and get a custom quote.`
    : `Hi, I'm interested in your ${title} package starting at ${price}. I'd like to discuss my requirements and get started.`;

  const whatsappUrl =
    `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;


  const handleGetStarted = () => {

    trackWhatsAppConversion();
    
    window.open(whatsappUrl, "_blank");
  };


  return (
    <>

      {/* =========================
          PACKAGE CARD
      ========================= */}

      <div className={`package-card ${popular ? "package-popular" : ""}`}>

        {/* TOP ICON AREA */}

        <div className="package-card-top">

          {popular && (
            <div className="popular-badge">
              <Star size={14} fill="currentColor" />
              MOST POPULAR
            </div>
          )}

          <div className="package-icon">
            {icon}
          </div>

        </div>


        {/* CONTENT */}

        <div className="package-card-content">

          <h3>{title}</h3>


          {/* PRICE */}

          <div className="package-price">

            {customPrice ? (
              <>
                <strong>Custom</strong>
                <span>pricing</span>
              </>
            ) : (
              <>
                <small>Starting</small>
                <strong>{price}</strong>
                <span>/project</span>
              </>
            )}

          </div>


          {/* DESCRIPTION */}

          <p className="package-description">
            {description}
          </p>


          {/* FEATURES */}

          <div className="package-features">

            {features.map((feature, index) => (
              <span
                className="package-feature"
                key={index}
              >
                <Check size={13} />
                {feature}
              </span>
            ))}

          </div>


          {/* BUTTONS */}

          <div className="package-actions">

            <button
              className={`package-start-btn ${
                popular ? "package-start-popular" : ""
              }`}
              onClick={handleGetStarted}
            >
              <FaWhatsapp className="package-whatsapp-icon" />

              Get Started
            </button>


            <button
              className="package-details-btn"
              onClick={() => setShowDetails(true)}
            >
              View Details
            </button>

          </div>

        </div>

      </div>


      {/* =========================
          DETAILS MODAL
      ========================= */}

      <PackageDetailsModal
        isOpen={showDetails}
        onClose={() => setShowDetails(false)}

        title={title}

        price={
          customPrice
            ? "Custom"
            : price
        }

        description={description}

        details={
          details.length > 0
            ? details
            : features
        }

        idealFor={idealFor}

        delivery={delivery}

        whatsappLink={whatsappUrl}
      />

    </>
  );
};

export default PackageCard;